import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/translation.en.json";
import translationTW from "./locales/translation.zh-TW.json";
import translationCN from "./locales/translation.zh-CN.json";
import translationJA from "./locales/translation.ja.json";
import translationTH from "./locales/translation.th.json";
import translationFIL from "./locales/translation.fil.json";
import translationID from "./locales/translation.id.json";
import translationVI from "./locales/translation.vi.json";
import translationKO from "./locales/translation.ko.json";

const resources = {
  en: {
    translation: translationEN,
  },
  "zh-TW": {
    translation: translationTW,
  },
  "zh-CN": {
    translation: translationCN,
  },
  ja: {
    translation: translationJA,
  },
  ko: {
    translation: translationKO,
  },
  th: {
    translation: translationTH,
  },
  fil: {
    translation: translationFIL,
  },
  id: {
    translation: translationID,
  },
  vi: {
    translation: translationVI,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "zh-TW",
    detection: {
      order: ["navigator"],
      caches: ["cookies"],
    },
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: "",
  });

export default i18n;
